/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Network service
 */

namespace Application.Services {
    'use strict';

    import Gateway = Models.Gateway;
    import IGateway = Models.IGateway;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;
    import PortMapping = Models.PortMapping;

    /**
     * GatewayService
     */
    export class GatewayService {
        public static $name: string = "gatewayService";
        public static $inject: string[] = ['backendService', 'healthService', 'vnoService'];

        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'networknodes/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'gateways';

        constructor(private backendService: BackendService,
                    private healthService: HealthService,
                    private vnoService: Services.VnoService) {
        }

        public getByHref(href: string, callback: (result: Gateway) => void): void {
            this.getGatewayPromise(href).then(
                (data: Gateway) => {
                    callback(data);
                }
            );
        }

        public getById(id: number): ng.IPromise<IGateway> {
            return this.backendService
                .get(this.backendUrl + '/' + id)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<IGateway>>) => {
                    let halElement: IHalElement<IGateway> = data.data;
                    let converted: IGateway = HalConverter.convertElement(halElement, Gateway.Empty);
                    converted.health = this.healthService.getNodeHealth(converted.href);
                    return converted;
                });

        }

        public getAllGateways(callback: (networks: IGateway[]) => void): void {
            this.getAllGatewaysPromise().then(
                (data: IGateway[]) => {
                    callback(data);
                });
        }

        public getAllGatewaysPromise(): ng.IPromise<IGateway[]> {
            return this.backendService.get(this.backendUrl + "/filtered?size=5000")
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<IGateway>>) => {
                    let halElement: IHalList<IGateway> = result.data;
                    let converted: IGateway[] = HalConverter.convertList(halElement, Gateway.Empty);
                    converted.forEach((element: IGateway) => {
                            this.setNetworkHrefs(element);
                            element.health = this.healthService.getNodeHealth(element.href);
                    });
                    return converted;
                });
        }

        public addPositionToGateway(href: string, x: number, y: number): ng.IPromise<Gateway> {
            return this.getGatewayPromise(href).then(
                 (gateway: Gateway) => {
                     gateway.x = x;
                     gateway.y = y;
                     return this.updateGateway(gateway);
                 }
            );
        }

        public saveGateway(gateway: Models.IGateway): ng.IPromise<Models.IGateway> {
            if (!gateway.href || gateway.href === undefined || gateway.href === '') {
                return this.createGateway(gateway);
            } else {
                return this.updateGateway(gateway);
            }
        }

        public createGateway(gateway: Models.IGateway): ng.IPromise<Models.IGateway> {
            return this.backendService.post(this.backendUrl, gateway).then (
                 (result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IGateway>>) => {
                     let converted: IGateway = HalConverter.convertElement(result.data, Gateway.Empty);
                     converted.health = this.healthService.getNodeHealth(converted.href);
                     return this.setNetworkHrefs(converted);
                 }
            );
        }

        public updateGateway(gateway: Models.IGateway): ng.IPromise<Models.IGateway> {
            return this.backendService.put(gateway.href, {
                    name: gateway.name,
                    natEnabled: gateway.natEnabled,
                    networkInterfaces: gateway.networkInterfaces.map(
                        (nic: Models.INetworkInterface) => {
                            return {
                                connected: nic.connected,
                                connectedToInternet: nic.connectedToInternet,
                                dhcp: nic.dhcp,
                                id: nic.id,
                                ipAddress: nic.ipAddress,
                                name: nic.name,
                                network:  nic.networkConnectedTo ? nic.networkConnectedTo.href : undefined,
                                networkConnectedTo: nic.networkConnectedTo,
                                type: nic.type,
                            };
                        }
                    ),
                    hostname: gateway.hostname,
                    x: gateway.x,
                    y: gateway.y,
                }).then (
                 (result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IGateway>>) => {
                     let converted: IGateway = HalConverter.convertElement(result.data, Gateway.Empty);
                     converted.health = this.healthService.getNodeHealth(converted.href);
                     return this.setNetworkHrefs(converted);
                 }
            );
        }

        public deleteGateway(gateway: Models.IGateway): ng.IPromise<boolean> {
            return this.backendService.delete(gateway.href);
        }

        public getPortMappingsByGateway(gateway: Models.IGateway): ng.IPromise<PortMapping[]> {
            return this.backendService.get(gateway.href + "/portMappings")
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<PortMapping>>) => {
                    let halElement: IHalList<PortMapping> = result.data;
                    let converted: PortMapping[] = HalConverter.convertList(halElement, PortMapping.Empty);
                    return converted;
                });
        }

        public setPortMappingsByGateway(gateway: Models.IGateway, mappings: PortMapping[]): ng.IPromise<void> {
            return this.backendService.post(gateway.href + "/portMappings", mappings)
                .then(() => { return; });
        }

        public getGatewayPromise(href: string): ng.IPromise<Gateway> {
            return this.backendService.get(href).then(
                (data: ng.IHttpPromiseCallbackArg<IHalElement<Gateway>>) => {
                    let halElement: IHalElement<Gateway> = data.data;
                    let converted: Gateway = HalConverter.convertElement(halElement, Gateway.Empty);
                    converted.health = this.healthService.getNodeHealth(converted.href);
                    return this.setNetworkHrefs(converted);
                }
            );
        }

        public getOrganizations(href: string): ng.IPromise<Models.Vno[]> {
            return this.getOrganizationIds(href)
                .then((res: number[]) => {
                    return this.vnoService.findAll()
                        .then((result: Models.Vno[]) => {
                            return result.filter( (vno: Models.Vno) => {
                                return res.indexOf( vno.id ) > -1;
                            });
                        });
                });
        }

        public getOrganizationIds(href: string): ng.IPromise<number[]> {
            return this.backendService.get(href + "/organization")
                .then((res: ng.IHttpPromiseCallbackArg<number[]>) => {
                    return res.data;
                });
        }

        public addOrganization(href: string, organizationId: number): ng.IPromise<boolean> {
            return this.backendService.post(href + "/organization/" + organizationId, {})
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        public removeOrganization(href: string, organizationId: number): ng.IPromise<boolean> {
            return this.backendService.delete(href + "/organization/" + organizationId)
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        public changeOrganizations(href: string, organizationIds: number[]): ng.IPromise<boolean> {
            return this.backendService
                .put(href + "/organizations", organizationIds)
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        private setNetworkHrefs(gateway: IGateway): IGateway {
            gateway.networkInterfaces.forEach(
                (nic: Models.INetworkInterface) => {
                    if (nic.networkConnectedTo) {
                        let id: number = nic.networkConnectedTo.id;
                        nic.networkConnectedTo.href =
                            this.backendBaseUrl + this.servicePath + 'networks/' + id;
                    }
                }
            );
            return gateway;
        }

        /**
         * This method checks if there is a gateway with the name provided
         *
         * @param name name to be checked
         * @return boolean true if the name is already in the database
         */
        public checkUsedNamePromise(name: string): ng.IPromise<boolean> {
            return this.backendService
                .get(this.backendUrl + "/usedName?name=" + name, false, undefined, false, false)
                .then((result: ng.IHttpPromiseCallbackArg<Boolean>) => {
                    return result.data;
                });
        }
    }
}